module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.showSuggest) ? _c('urs-input', {
    ref: "input",
    attrs: {
      "placeholder": "用户名",
      "name": _vm.name,
      "initialValue": _vm.preFilter(_vm.initialValue)
    },
    on: {
      "blur": _vm.onBlur,
      "focus": function($event) {
        _vm.onFocus(false)
      }
    }
  }, [_c('span', {
    staticClass: "suggest_single",
    slot: "icon-button"
  }, [_vm._v(_vm._s(_vm.singleSuffix))])]) : _vm._e(), _vm._v(" "), (_vm.showSuggest) ? _c('urs-input', {
    ref: "input",
    attrs: {
      "placeholder": _vm.placeholder,
      "name": _vm.name,
      "initialValue": _vm.initialValue
    },
    on: {
      "input": _vm.onShow,
      "focus": function($event) {
        _vm.onFocus(true)
      },
      "blur": _vm.onBlur,
      "delete": _vm.onDelete
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "suggest_drop",
    on: {
      "mousedown": _vm.onSelect
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('span', [_vm._v(_vm._s(item))])])
  }))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7632db8f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Suggest.vue
// module id = 518
// module chunks = 1